export function formatBinSetName(binNames) {
  if (!binNames || binNames.length === 0) {
    return null;
  }

  if (binNames.length === 1) {
    return `Bin ${binNames[0]}`;
  }

  if (binNames.length === 2) {
    return `Bins ${binNames.join(' & ')}`;
  }

  return `Bins ${binNames.slice(0, binNames.length - 1).join(', ')} & ${binNames[binNames.length - 1]}`;
}

export default function useFormattedBinSetName() {
  return {
    formatBinSetName,
  };
}
